// Paragraph.js (Modified to use Animation.js Observer)

import Animation from '../classes/Animation';
import GSAP from 'gsap';
import { SplitText } from "gsap/SplitText";

GSAP.registerPlugin(SplitText);

export default class Paragraph extends Animation {
  constructor({ element, elements }) {
    super({ element, elements }); // Calls Animation.js, which sets up the observer



    this.splitText()
  }

  splitText() {
    if (!this.element) return;

    // 1. Create SplitText
    this.split = new SplitText(this.element, {
      type: "words, lines",
      linesClass: "line"
    });

    this.lines = this.split.lines;

    GSAP.set(this.element, { opacity: 1 });
    GSAP.set(this.lines, { y: "100%", autoAlpha: 0 });
  }

  animateIn() {

    if (this.isVisible) return; // Prevent double-triggering
    super.animateIn(); // Set this.isVisible = true

    GSAP.to(this.lines, {
      y: "0%",
      autoAlpha: 1,
      duration: 0.75,
      ease: 'expo.out',
      stagger: 0.1,
    });
  }

  animateOut() {

  }

  destroy() {
    this.split?.revert();

  }
}